import { CLOUD_MANAGEMENT, KEY_MANAGEMENT, MANAGE_DATA_ACCESS_ROLES, MANAGE_DATA_ACCESS_TOKENS, MANAGE_DATA_CLASSIFICATIONS, 
  MANAGE_DATA_OWNER_GROUPS, MANAGE_OBFUSCATION_RULES, MANAGE_ONDATA_CLIENTS, ORGANIZATION_USERS, Permissions_new } from "~/constants"


export type SettingsMenuItem =
| 'Organization'
| 'Data Access Policy'
| 'Encryption'
| 'Deployment'
| 'Notification'

export const allowedSettingsMenus = (ps: Permissions_new|Permissions_new[]) => {
  const menuItems = new Set<SettingsMenuItem>([
    'Organization', // user can always register/view clients
    'Encryption',   // user can always view DataAccessTokens/ObfsRules
    'Data Access Policy', // user can always view DataClassification, etc.
  ])
  const x = {
    [ORGANIZATION_USERS]: ['Notification'],
    [CLOUD_MANAGEMENT]: ['Deployment'],
  } as {[p in Permissions_new]: SettingsMenuItem[]}
  const ps2 = !(ps instanceof Array) ? [ps] : ps
  return ps2.reduce((acc, p) => {
    if (x[p]) {
      x[p].forEach(item => acc.add(item))
    }
    return acc
  }, menuItems)
}


export const getSettingsMenuDefaultRoute = (item1:SettingsMenuItem|{name:SettingsMenuItem,hasDriverFeature:boolean}, ps:Permissions_new[]) => {
  const pSet = new Set<Permissions_new>(ps ?? [])
  const item = typeof(item1) === 'string' ? item1 : item1.name
  switch (item) {
    case 'Organization':
      return (
        pSet.has(ORGANIZATION_USERS) 
        ? '/settings/organization/profile/edit'
        : '/settings/organization/clients')
    case 'Data Access Policy':
      return ('/settings/governance/data-classification')
    case 'Encryption':
      const hasDriverFeature = typeof(item1) !== 'string' && item1.hasDriverFeature
      return (
        pSet.has(KEY_MANAGEMENT) ? '/settings/encryption/keys'
      : hasDriverFeature         ? '/settings/encryption/tokens'
      : '/settings/encryption/obfuscation-rule')
    case 'Deployment':
      return (pSet.has(CLOUD_MANAGEMENT) ? '/settings/deployment' : null)
    case 'Notification':
      return (pSet.has(ORGANIZATION_USERS) ? '/settings/notification' : null)
    default: return null;
  }
}


export const allowOrgSettingRoute = (path:string, ps: Permissions_new[], hasFeature: {
  OnDataDriver: boolean;
  OnDataSecureFile: boolean;
}):boolean => {
  const path_l = path.toLowerCase()
  let p : Permissions_new|null|boolean =
    ['/settings/organization/profile',
     '/settings/organization/user-manage',
     '/settings/organization/sso-config',].some(x => path_l.startsWith(x)) ? ORGANIZATION_USERS
    
     // allow all user to see registered clients, because they can register encrypt tool/database driver
     // but for manage client actions, they require 'MANAGE_ONDATA_CLIENTS' permit, which should be checked on clients tab ui component
  : ['/settings/organization/clients'].some(x => path_l.startsWith(x))     ? true 
  
  : ['/settings/organization/cloud-subscription',
     '/settings/organization/ip-whitelist',].some(x => path_l.startsWith(x)) ? CLOUD_MANAGEMENT
  : null
  return p === true || (!!p && ps.includes(p))
}

export const OrgSettingPermits:Permissions_new[][] = [[ORGANIZATION_USERS], [MANAGE_ONDATA_CLIENTS], [CLOUD_MANAGEMENT]]


export const allowDataAccessSettingRoute = (path:string, ps:Permissions_new[]) => {
  const path_l = path.toLowerCase()
  return path_l.startsWith('/settings/governance')
}

export const DataAccessSettingPermits:Permissions_new[][] = [[MANAGE_DATA_CLASSIFICATIONS], [MANAGE_DATA_ACCESS_ROLES], [MANAGE_DATA_OWNER_GROUPS]]


export const allowEncryptSettingRoute = (path:string, hasDriverFeature:boolean, ps:Permissions_new[]):boolean => {
  const path_l = path.toLowerCase()
  const p : Permissions_new|null|boolean =
    ['/settings/encryption/keys',].some(x => path_l.startsWith(x))             ? KEY_MANAGEMENT
  : ['/settings/encryption/tokens',].some(x => path_l.startsWith(x))           ? hasDriverFeature
  : ['/settings/encryption/obfuscation-rule',].some(x => path_l.startsWith(x)) ? true
  : null
  return p === true || (!!p && ps.includes(p))
}

export const EncryptSettingPermits:Permissions_new[][] = [[KEY_MANAGEMENT], [MANAGE_DATA_ACCESS_TOKENS], [MANAGE_OBFUSCATION_RULES]]

